"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarTimeDefaultProps = exports.CalendarTime = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _RadioButton = _interopRequireWildcard(require("../../../elements/Forms/RadioButton"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CalendarTime = function CalendarTime(props) {
  var classNames = props.classNames,
      date = props.date,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(date.getHours()),
      _useState2 = _slicedToArray(_useState, 2),
      hours = _useState2[0],
      setHours = _useState2[1];

  var _useState3 = (0, _react.useState)(date.getMinutes()),
      _useState4 = _slicedToArray(_useState3, 2),
      minutes = _useState4[0],
      setMinutes = _useState4[1];

  var _useState5 = (0, _react.useState)(date.getHours() > 11 ? 'PM' : 'AM'),
      _useState6 = _slicedToArray(_useState5, 2),
      period = _useState6[0],
      setPeriod = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      errorHours = _useState8[0],
      setErrorHours = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      errorMinutes = _useState10[0],
      setErrorMinutes = _useState10[1];

  var timeClassNames = (0, _classnames.default)({
    'calendar-component__time': true
  }, classNames);
  var timeHoursClassNames = (0, _classnames.default)({
    'calendar-component__time__hour': true,
    'calendar-component__time__hour--error': errorHours
  });
  var timeMinutesClassNames = (0, _classnames.default)({
    'calendar-component__time__minute': true,
    'calendar-component__time__minute--error': errorMinutes
  });
  var timePeriodClassNames = (0, _classnames.default)('calendar-component__time__period');
  (0, _react.useEffect)(function () {
    var newDate = new Date(date);
    newDate.setHours(hours, minutes);

    if (newDate.getTime() !== date.getTime() && onChange) {
      onChange(newDate);
    }
  }, [hours, minutes, date, onChange]);

  var _handleChangeMinutes = function _handleChangeMinutes(event) {
    // @ts-ignore - value does exist here.
    var newValue = parseInt(event.currentTarget.value, 10);

    if (Number.isNaN(newValue)) {
      newValue = 0;
      setErrorMinutes(true);
    } else if (newValue < 0) {
      newValue = 0;
      setErrorMinutes(true);
    } else if (newValue > 59) {
      newValue = 59;
      setErrorMinutes(true);
    } else {
      setErrorMinutes(false);
    }

    if (newValue >= 0 && newValue <= 59) {
      setMinutes(newValue);
    }
  };

  var _handleChangeHours = function _handleChangeHours(event) {
    // @ts-ignore - value does exist here.
    var newValue = parseInt(event.currentTarget.value, 10);

    if (Number.isNaN(newValue)) {
      newValue = 0;
      setErrorHours(true);
    } else if (newValue < 0) {
      newValue = 0;
      setErrorHours(true);
    } else if (newValue > 11) {
      newValue = 11;
      setErrorHours(true);
    } else {
      setErrorHours(false);
    }

    if (newValue >= 0 && newValue <= 11) {
      var newHoursValue = newValue + (period === 'PM' ? 12 : 0);
      setHours(newHoursValue);
    }
  };

  var _handleChangePeriod = function _handleChangePeriod(event, index, currentlySelected, currentValue) {
    var newPeriodValue = currentValue;

    if (typeof newPeriodValue === 'undefined' || newPeriodValue !== 'AM' && newPeriodValue !== 'PM') {
      newPeriodValue = 'AM';
    }

    var newHoursValue = hours;

    if (newHoursValue > 11 && newPeriodValue === 'AM') {
      newHoursValue -= 12;
    }

    if (newHoursValue <= 11 && newPeriodValue === 'PM') {
      newHoursValue += 12;
    }

    setPeriod(newPeriodValue);
    setHours(newHoursValue);
  };

  var periodAMactive = period === 'AM';
  var periodPMactive = period === 'PM';
  var hourValue = (hours % 12).toString().padStart(1, '0');
  var minuteValue = minutes.toString().padStart(2, '0');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: timeClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: timeHoursClassNames
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    min: 0,
    max: 11,
    value: hourValue,
    onChange: _handleChangeHours
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'calendar-component__time__divider16'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: timeMinutesClassNames
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    min: 0,
    max: 59,
    value: minuteValue,
    onChange: _handleChangeMinutes
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'calendar-component__time__divider12'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: timePeriodClassNames
  }, /*#__PURE__*/_react.default.createElement(_RadioButton.RadioButtonGroup, {
    onClick: _handleChangePeriod
  }, /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
    value: "AM",
    label: "AM",
    checked: periodAMactive
  }), /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
    value: "PM",
    label: "PM",
    checked: periodPMactive
  }))));
};

exports.CalendarTime = CalendarTime;
CalendarTime.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  date: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var CalendarTimeDefaultProps = {
  classNames: {}
};
exports.CalendarTimeDefaultProps = CalendarTimeDefaultProps;
CalendarTime.defaultProps = CalendarTimeDefaultProps;
var _default = CalendarTime;
exports.default = _default;